var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as _ from "lodash";
import Input from './Input';
import styled from 'styled-components';
import { getColor } from '../helpers/ColorHelpers';
import { aboveBreakpoint } from '../theme/DefaultTheme';
var SearchContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    height: ", ";\n    transition: all 0.2s ease-in-out;\n    cursor: help;\n\n    &:hover, \n    &:focus-within {\n        background: ", "; \n        input {\n            color: ", ";\n        }\n        svg {\n            stroke: ", ";\n        }\n    }\n    input{\n        font-family: ", ";\n    }\n    input:focus {\n        outline: none;\n    }\n"], ["\n    position: relative;\n    height: ", ";\n    transition: all 0.2s ease-in-out;\n    cursor: help;\n\n    &:hover, \n    &:focus-within {\n        background: ", "; \n        input {\n            color: ", ";\n        }\n        svg {\n            stroke: ", ";\n        }\n    }\n    input{\n        font-family: ", ";\n    }\n    input:focus {\n        outline: none;\n    }\n"])), function (props) { return props.fitHeight ? aboveBreakpoint(props, "tablet") ? "100%" : "unset" : "unset"; }, function (props) { return props.fitHeight ? aboveBreakpoint(props, "tablet") ? getColor(props, props.theme.colors.accent) : "transparent" : "transparent"; }, function (props) { return props.fitHeight ? aboveBreakpoint(props, "tablet") ? getColor(props, props.theme.colors.mainBackground) : undefined : undefined; }, function (props) { return props.fitHeight ? aboveBreakpoint(props, "tablet") ? getColor(props, props.theme.colors.mainBackground) : undefined : undefined; }, function (props) { return props.theme.fontFamily; });
var ResultsContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: ", ";\n    border: 1px solid;\n    border-color: ", ";\n    margin-top: -12px;\n    box-shadow: 0 5px 3px -4px ", ";\n    position: absolute;\n    width: 100%;\n    max-height: 250px;\n    overflow-y: auto;\n    z-index: 10;\n    font-family: ", ";\n"], ["\n    background-color: ", ";\n    border: 1px solid;\n    border-color: ", ";\n    margin-top: -12px;\n    box-shadow: 0 5px 3px -4px ", ";\n    position: absolute;\n    width: 100%;\n    max-height: 250px;\n    overflow-y: auto;\n    z-index: 10;\n    font-family: ", ";\n"])), function (props) { return getColor(props, props.theme.colors.mainBackground); }, function (props) { return getColor(props, props.theme.search.borderColor); }, function (props) { return getColor(props, props.theme.colors.accentBlack); }, function (props) { return props.theme.fontFamily; });
var Result = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 0.75em;\n    cursor: pointer;\n\n    &:hover{\n    background-color: ", ";\n    color: ", ";\n    }\n"], ["\n    padding: 0.75em;\n    cursor: pointer;\n\n    &:hover{\n    background-color: ", ";\n    color: ", ";\n    }\n"])), function (props) { return getColor(props, props.theme.search.resultHoverColor); }, function (props) { return getColor(props, props.theme.colors.mainBackground); });
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search(props) {
        var _this = _super.call(this, props) || this;
        _this.setActive = function () {
            var value = _this.state.value;
            if (value)
                _this.setState({ active: true });
        };
        _this.setInactive = function () {
            var itemHovered = _this.state.itemHovered;
            if (!itemHovered)
                _this.setState({ active: false });
        };
        _this.onChange = function (value) {
            var searchFunction = _this.props.searchFunction;
            var results = searchFunction(value);
            _this.setState({ value: value, results: results, active: value ? value.length > 0 : false });
        };
        _this.setHovered = function () {
            _this.setState({ itemHovered: true });
        };
        _this.setUnhovered = function () {
            _this.setState({ itemHovered: false });
        };
        _this.onClick = function (onClick) {
            _this.setState({ active: false, itemHovered: false });
            onClick();
        };
        _this.state = {
            results: [],
        };
        return _this;
    }
    Search.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.state, active = _b.active, results = _b.results;
        var noResults = this.props.noResults;
        return (React.createElement(SearchContainer, { onFocus: this.setActive, onBlur: this.setInactive, fitHeight: this.props.fitHeight ? true : false },
            React.createElement(Input, { placeHolder: "Search...", icon: "search", change: this.onChange, kind: (_a = this.props.kind) !== null && _a !== void 0 ? _a : "default" }),
            active && React.createElement(ResultsContainer, null, results.length > 0 ?
                _.map(results, function (result, idx) {
                    var onClick = function () { return _this.onClick(result.onClick); };
                    return (React.createElement(Result, { onClick: onClick, key: idx, onMouseOver: _this.setHovered, onMouseLeave: _this.setUnhovered }, result.node));
                })
                :
                    React.createElement(Result, null, noResults))));
    };
    return Search;
}(React.PureComponent));
export default Search;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Search.js.map